/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import RoomEvent from '../../event/RoomEvent'
import { List, Record } from 'immutable'

const RoomState = Record({
  id: '',
  name: ''
})

const SensorState = Record({
  current_sound_level: 0,
  current_temperature: 0,
  current_voltage: 0
})

const RoomStatusState = Record({
  room: new RoomState(),
  sensors: List([new SensorState()])
})

class RoomStatusStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([new RoomStatusState()])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case RoomEvent.getStatus:
        return List(
          payload.map(_ => {
            return new RoomStatusState(_)
          })
        )
      default:
        return state
    }
  }
}

export default new RoomStatusStore()
